<template>
  <div class="sharedata-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="下单时间">
              <el-date-picker
                v-model="searchForm.opertime"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="订单类型">
              <el-select v-model="searchForm.type" style="width: 120px" filterable clearable @keyup.enter.native="Search">
                <el-option-group label="">
                  <el-option label="正单" :value="0" />
                  <el-option label="补单" :value="5" />
                </el-option-group>
                <el-option-group label="补单类型">
                  <el-option label="客改单" :value="1" />
                  <el-option label="增补单" :value="2" />
                  <el-option label="色板单" :value="3" />
                  <el-option label="售后单" :value="4" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div v-loading="loading" class="card-content">
            <el-table
              :data="tableData"
              stripe
              :row-style="{cursor: 'pointer'}"
              style="width: 100%"
            >
              <el-table-column
                label="订单号"
                width="120"
                fixed
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.ordernum }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="生产单号"
                width="120"
                fixed
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span style="font-weight: 500;color:#409EFF">{{ scope.row.produnum }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="订单类型"
                width="120"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.type===0">正单</span>
                  <span v-if="scope.row.type===1">客改单</span>
                  <span v-if="scope.row.type===2">增补单</span>
                  <span v-if="scope.row.type===3">色板单</span>
                  <span v-if="scope.row.type===4">售后单</span>
                </template>
              </el-table-column>
              <el-table-column
                label="经销商"
                width="160"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.all_name }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="客户名称"
                width="160"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.custname }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="下单时间"
                width="170"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.time }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="详细地址"
                min-width="120"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.address }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="当前状态"
                width="100"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.mark===13" :disable-transitions="true" size="mini" class="tcf-tag-11">订单生产</el-tag>
                  <el-tag v-if="scope.row.mark===100" :disable-transitions="true" size="mini">已完成</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                width="240"
                fixed="right"
                align="center"
                label="操作"
              >
                <template slot-scope="scope">
                  <el-button size="mini" @click="editRow(scope.row)"><i class="el-icon-upload2"></i> 上传图片</el-button>
                  <el-button size="mini" @click="lookImg(scope.row)"><i class="el-icon-picture-outline"></i> 查看图库</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              :current-page="currentPage"
              :page-sizes="[10, 20, 40]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
        <el-dialog
          :title="editTitle"
          :visible.sync="dialogVisible"
          width="800px"
          top="10vh"
          :destroy-on-close="true"
          :lock-scroll="true"
          :append-to-body="true"
        >
          <div v-loading="editFormLoading">
            <el-form ref="editForm" size="small" :model="editForm" label-width="80px" style="padding:15px 30px 15px 15px;" :rules="editRules">
              <el-form-item label="上传图片" prop="multiImg">
                <MultiDragImg :key="key" v-model="editForm.multiImg" :limit="99999" :size="'sm'"></MultiDragImg>
              </el-form-item>
              <el-form-item label="类型" prop="type">
                <el-radio v-model="editForm.type" :label="0">产前样图库</el-radio>
                <el-radio v-model="editForm.type" :label="1">木工试装</el-radio>
                <el-radio v-model="editForm.type" :label="2">半成品试装</el-radio>
                <el-radio v-model="editForm.type" :label="3">成品试装</el-radio>
                <el-radio v-model="editForm.type" :label="4">五金配件</el-radio>
              </el-form-item>
              <el-form-item>
                <el-button :loading="btnLoading" type="primary" @click="addImg('editForm')">立即提交</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-dialog>
        <el-dialog
          :title="imgTitle"
          :visible.sync="imgVisible"
          width="80%"
          top="10vh"
          :destroy-on-close="true"
          :lock-scroll="true"
          :append-to-body="true"
        >
          <el-select v-model="imgSearchForm.type" placeholder="请选择" size="mini" clearable @change="imgSearch()">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <div v-if="this.imgData.length === 0">
            此订单暂未上传图片~
          </div>
          <ul v-loading="imgLoading" class="sharedata-list">
            <li v-for="d in imgData">
              <div class="sharedata-img">
                <el-image
                  class="img"
                  :src="d.path"
                  :preview-src-list="[d.path]"
                >
                </el-image>
              </div>
              <div class="sharedata-author"><i class="el-icon-user-solid" /> {{ d.name }}</div>
              <div v-if="d.type===0" class="sharedata-author"><i class="el-icon-share" />产前样图库</div>
              <div v-else-if="d.type===1" class="sharedata-author"><i class="el-icon-share" />木工试装</div>
              <div v-else-if="d.type===2" class="sharedata-author"><i class="el-icon-share" />半成品试装</div>
              <div v-else-if="d.type===3" class="sharedata-author"><i class="el-icon-share" />成品试装</div>
              <div v-else class="sharedata-author"><i class="el-icon-share" />五金配件</div>
              <div class="sharedata-info">
                <span><i class="el-icon-time"></i>{{ d.time }}</span>
              </div>
              <el-button size="mini" @click="deleteImg(d)">删除</el-button>
            </li>
          </ul>
          <el-pagination
            v-if="imgTotal>0"
            background
            :current-page="imgCurrentPage"
            :page-sizes="[10, 20, 40]"
            :page-size="imgPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="imgTotal"
            @size-change="imgHandleSizeChange"
            @current-change="imgHandleCurrentChange"
          >
          </el-pagination>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import MultiImg from '@/components/upload/MultiImg'
import { addImg, getPztkOrderList, selectQualityImgList, deleteQualityImg } from '@/api/erp'
import MultiDragImg from '@/components/upload/MultiDragImg'

export default {
  name: 'Pztk',
  components: { MultiDragImg, MultiImg },
  data() {
    return {
      loading: false,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      imgTotal: 0,
      imgCurrentPage: 1,
      imgPageSize: 10,
      imgTitle: '',
      imgVisible: false,
      imgLoading: false,
      dialogImageUrl: null,
      dialogImageVisible: false,
      editTitle: '',
      editFormLoading: false,
      dialogVisible: false,
      tableData: [],
      imgData: [],
      options: [{
        label: '产前样图库',
        value: 0
      }, {
        label: '木工试装',
        value: 1
      }, {
        label: '半成品试装',
        value: 2
      }, {
        label: '成品试装',
        value: 3
      }, {
        label: '五金配件',
        value: 4
      }],
      searchForm: {
        type: null,
        search: '',
        opertime: []
      },
      imgSearchForm: {
        orderid: null,
        type: null
      },
      key: 0,
      editForm: {
        orderid: null,
        oldorderid: null,
        multiImg: [],
        type: 0
      },
      btnLoading: false,
      editRules: {
        orderid: [{ required: true, message: '请选择订单', trigger: 'change' }],
        multiImg: [{ required: true, message: '请添加图片', trigger: 'change' }],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }]
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
  },
  methods: {
    imgSearch() {
      this.imgLoading = true
      this.imgCurrentPage = 1
      this.selectQualityImgList()
    },
    deleteImg(d) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          qiid: d.qiid,
          userid: this.user.dUserid,
          groupid: this.user.dGroupid,
          role: this.user.role
        }
        deleteQualityImg(data).then(response => {
          this.selectQualityImgList()
        })
      })
    },
    Search() {
      this.currentPage = 1
      this.getData()
    },
    lookImg(row) {
      this.imgVisible = true
      this.imgLoading = true
      this.imgTitle = row.ordernum + '/' + row.produnum + '图库'
      this.imgSearchForm.orderid = row.orderid
      this.imgSearchForm.type = null
      this.imgCurrentPage = 1
      this.selectQualityImgList()
    },
    selectQualityImgList() {
      const data = {
        orderid: this.imgSearchForm.orderid,
        page: this.imgCurrentPage,
        limit: this.imgPageSize,
        type: this.imgSearchForm.type
      }
      selectQualityImgList(data).then(response => {
        this.imgTotal = response.total
        this.imgData = response.data
        this.imgLoading = false
      }).catch(() => {
        this.imgLoading = false
      })
    },
    getData() {
      this.loading = true
      let startTime = ''
      let endTime = ''
      if (this.searchForm.opertime !== null && this.searchForm.opertime.length === 2) {
        startTime = this.searchForm.opertime[0]
        endTime = this.searchForm.opertime[1]
      }
      const data = {
        starttime: startTime,
        endtime: endTime,
        content: this.searchForm.search,
        type: this.searchForm.type,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        role: this.user.role,
        mark: 13
      }
      getPztkOrderList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    addImg(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          const data = {
            orderid: this.editForm.orderid,
            multiImg: this.editForm.multiImg.toString(),
            type: this.editForm.type,
            userid: this.user.dUserid
          }
          addImg(data).then(response => {
            this.$message({
              message: response.msg,
              type: 'success'
            })
            this.getData()
            this.btnLoading = false
            this.dialogVisible = false
          }).catch(() => {
            this.btnLoading = false
          })
        }
      })
    },
    editRow(row) {
      this.editTitle = row.ordernum + '/' + row.produnum + '上传图片'
      this.editForm.orderid = row.orderid
      this.editForm.multiImg = []
      this.dialogVisible = true
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    imgHandleSizeChange(val) {
      this.imgPageSize = val
      this.imgCurrentPage = 1
      this.selectQualityImgList()
    },
    imgHandleCurrentChange(val) {
      this.imgCurrentPage = val
      this.selectQualityImgList()
    }
  }
}
</script>

<style lang="scss" scoped>
  .sharedata-container {
    .sort{
      position: relative;
      padding: 0;
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #f5f7fa;
      .wrap{
        box-sizing: content-box;
        .sort-mode{
          overflow: visible;
          float: left;
          .sort-btn{
            color: #606266;
            font-size: 13px;
            font-weight: 400;
            margin-right: 20px;
          }
          .sort-this{
            color: #409EFF;
            font-weight: 500;
          }
        }
        .search-mode{
          float: right;
          width: 300px;
          .search-input{
            background-color: #F2F6FC;
            border:0;
            height: 32px;
            line-height: 32px;
            border-radius: 4px;
            color: #606266;
            padding: 0 40px 0 15px;
            -webkit-appearance: none;
            font-size: 12px;
            width: 100%;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            outline: 0;
            &::-webkit-input-placeholder {
              color: #C0C4CC;
            }
            &::-ms-input-placeholder {
              color: #C0C4CC;
            }
          }
          .search-btn{
            position: absolute;
            right: 0;
            height: 32px;
            width: 40px;
            line-height: 32px;
            top: 10px;
            border: 0;
            background: transparent;
            text-align: center;
            padding: 0;
          }
        }
      }
    }
  }
  .sharedata-list{
    padding: 0;
    margin: 20px 0;
    width: 100%;
    position: relative;
    list-style: none;
    min-height: 100px;
    li{
      width: 460px;
      height: 130px;
      padding: 10px 10px 10px 100px;
      position: relative;
      cursor: pointer;
      float: left;
      margin: 10px;
      border-radius: 2px;
      .sharedata-img{
        position: absolute;
        left: 10px;
        top: 20px;
        width: 80px;
        height: 80px;
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
        border-radius: 2px;
      }
      .sharedata-title{
        padding-top: 2px;
        line-height: 20px;
        font-size: 14px;
        width: 100%;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .sharedata-author{
        color:#999;
        font-size: 12px;
        line-height: 20px;
      }
      .sharedata-info{
        width: 100%;
        line-height: 20px;
        color:#999;
        font-size: 12px;
        span{
          margin-right: 20px;
          &:last-child{
            margin-right: 0;
          }
        }
      }
      &:hover{
        background: #f5f7fa;
        .sharedata-title{
          color:#409EFF;
        }
      }
    }
    &:after{
      content: ' ';
      display: table;
      clear: both;
    }
  }
  .demo-input-suffix{
    padding: 10px;
    margin: auto;
  }
</style>
